import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsVPPAdminVisitorListParm } from "./wsVPPAdminVisitorListParm";
import { wsVPPAdminVisitorPrintDataParm } from "./wsVPPAdminVisitorPrintDataParm";
import { wsVPPAdminVisitorEditDataParm } from "./wsVPPAdminVisitorEditDataParm";
import { wsVPPAdminVisitorEditAddBlockedParm } from "./wsVPPAdminVisitorEditAddBlockedParm";
import { wsVPPAdminVisitorEditModifyParm } from "./wsVPPAdminVisitorEditModifyParm";
import { wsVPPAdminVisitorVerifyModifyParm } from "./wsVPPAdminVisitorVerifyModifyParm";
import { wsVPPAdminVisitorOffenderLookupDataParm } from "./wsVPPAdminVisitorOffenderLookupDataParm";
import { wsVPPAdminVisitorImportBlockDataParm } from "./wsVPPAdminVisitorImportBlockDataParm";
import { wsVPPAdminVisitorImportBlockedListParm } from "./wsVPPAdminVisitorImportBlockedListParm";
import * as moment from "moment";

@Injectable()
export class DataService_viewvisitor {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorSelectList(parms: wsVPPAdminVisitorListParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorPrintDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorPrintDataGet(parms: wsVPPAdminVisitorPrintDataParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorPrintDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Print
	//
	//-----------------------------------------------------------------------------------------------------
	Print_RPTVisitorLog(
		Visitor_PersonID: number,
		VisitorLogStatusID: number,
		StartDate: Date,
		EndDate: Date,
		FacilityID: number,
		SortByCD: string,
		isASC: boolean,
		UserID: number
	) {
		var strSortDirection: string = "";
		var strStartDate: string = (strStartDate = moment(StartDate).format("MM/DD/YYYY") + " 00:00:00 AM");
		var strEndDate: string = (strEndDate = moment(EndDate).format("MM/DD/YYYY") + " 00:00:00 AM");

		if (FacilityID < 0) {
			FacilityID = 0;
		}

		if (isASC == true) {
			strSortDirection = "Ascending";
		} else {
			strSortDirection = "Descending";
		}

		//
		//	Build strParam
		//
		var strParam: string =
			Visitor_PersonID.toString() +
			"|" +
			"PersonID," +
			VisitorLogStatusID.toString() +
			"|" +
			"ByVisit," +
			strStartDate +
			"|" +
			"StartDate," +
			strEndDate +
			"|" +
			"EndDate," +
			FacilityID.toString() +
			"|" +
			"FacilityID," +
			SortByCD +
			"|" +
			"SortBy," +
			strSortDirection +
			"|" +
			"SortDirection," +
			UserID.toString() +
			"|" +
			"UserID";

		var reportFileName = "RptVisitorVisits.rpx";
		var strSchoolID: string = "-1";

		//
		//	Generate PDF
		//
		var postResult$ = new Subject();
		var url = "Report/PrintByReportFileName?ReportFileName=" + reportFileName + "&strParam=" + strParam + "&schoolID=" + strSchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.next(error);
			}
		);

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorEditDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorEditDataGet(parms: wsVPPAdminVisitorEditDataParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorEditDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminEditVisitorAddBlocked
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminEditVisitorAddBlocked(parms: wsVPPAdminVisitorEditAddBlockedParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminEditVisitorAddBlocked";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminEditVisitorEdit
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminEditVisitorEdit(parms: wsVPPAdminVisitorEditModifyParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminEditVisitorEdit";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVerifyVisitorEdit
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVerifyVisitorEdit(parms: wsVPPAdminVisitorVerifyModifyParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVerifyVisitorEdit";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorVerifyOffenderLookup
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorVerifyOffenderLookup(parms: wsVPPAdminVisitorOffenderLookupDataParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorVerifyOffenderLookup";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorImportBlockDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorImportBlockDataGet(parms: wsVPPAdminVisitorImportBlockDataParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorImportBlockDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminEditVisitorAddBlockedList
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminEditVisitorAddBlockedList(parms: wsVPPAdminVisitorImportBlockedListParm) {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminEditVisitorAddBlockedList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorTransferToVPP3
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorTransferToVPP3() {
		var postResult$ = new Subject();
		var url = "Visitor/VPPAdminVisitorTransferToVPP3";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
